import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform } from "react-native";
import NewIssue from "../dialogs/newIssue";
import BarcodeScannerComponent from "../widgets/BarCodeScannerComponent";
import colors from "../../constants/colors";
//import { Audio } from 'expo-av';
import { inputFocus } from "../../utils";
import { getNoAutofillProps, isMobileWeb, noAutofillRef } from "../../utils/mobileWeb";

export default class Textarea extends Component {
  inputRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initial,
      height: 100,
      heightIOS: 33,
      scan: false,

    };
    this.textInputRef = createRef(null);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initial != this.props.initial) {
      this.setState({ value: nextProps.initial });
    }
  }

  getStyle() {
    var style = {
      fontSize: 20,
      color: "#424242",
      fontWeight: "400",
      height: 100,
      borderColor: "#e7e7e7",
      borderWidth: 1,
      borderRadius: 5,
      paddingLeft: 10,
      paddingTop: 10,
      fontFamily: "Roboto",
      dialogVisible: false,
      scanerCanceled: false
    };

    if (this.props.label == "TK Trainer Comments") {
      style["color"] = "#d00";
      style["borderColor"] = "#d00";
    }

    return style;
  }
  async handleBarCodeScanned(data) {
    const { onChange, id } = this.props;
    this.setState({ scan: false }, async () => {
      //Activate sound for barcode
      //const { sound } = await Audio.Sound.createAsync(require('../../../assets/audio/scanner-audio.mp3'));
      //await sound.playAsync();

      if (data) {
        this.setState({ value: data });
        onChange(id, data);
      }
    });
  }
  getMinChar(width) {
    var chrs = 26;
    switch (width) {
      case "small":
        chrs = 13
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return chrs;
  }
  getFirstDiv(width) {
    var val = 19;
    switch (width) {
      case "small":
        val = 11
        break;
      case "medium":
        break;
      case "large":
        break;
    }
    return val;
  }
  getSecondDiv(width) {
    var val = 25;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 19
        break;
      case "large":
        val = 25;
        break;
    }
    return val;
  }
  getThirdDiv(width) {
    var val = 31;
    switch (width) {
      case "small":
        val = 13
        break;
      case "medium":
        val = 24
        break;
      case "large":
        break;
    }
    return val;
  }
  showScanner(value) {
    this.setState({ scan: value, scanerCanceled: value ? false : this.state.scanerCanceled });
  }
  renderInputView() {
    const { value } = this.state;
    const { width } = this.props;

    return <View style={{
      borderColor: "#e7e7e7",
      borderRadius: 5,
      borderWidth: 1,
      color: "#424242",
      fontFamily: "Roboto",
      fontSize: 20,
      fontWeight: "400",
      paddingLeft: 10,
      height: Platform.OS === 'ios' ?
        this.state.value !== '' ? this.state.heightIOS * 1.3 : this.props.placeholder && this.props.placeholder.length <= 50 ? this.state.heightIOS * 1.15 : this.state.heightIOS * 1.1 :
        //Android
        this.state.value == "" || !this.state.value
          ? this.props.placeholder && this.props.placeholder.length >= this.getMinChar(width)
            ? this.props.placeholder.length <= 50 ? (this.state.height * (this.props.placeholder.length / this.getFirstDiv(width))) : this.props.placeholder.length <= 200 ? (this.state.height * (this.props.placeholder.length / this.getSecondDiv(width))) : (this.state.height * (this.props.placeholder.length / this.getThirdDiv(width)))
            : this.state.height
          : (this.state.value.length / 31) <= 0 ? (this.state.height * (this.state.value.length / 28))
            : this.state.height,
      fontStyle: this.state?.value == "" || !this?.state.value ? 'italic' : 'normal'
    }}></View>;
  }
  render() {
    const { value, scan, scanerCanceled } = this.state;
    const { label, onChange, id, isIssuable, onSubmitIssue, isCompleted, showScanner, width, openIssue, defaultComponent, handleFocusOnElement, hideInput, scannerInput, isInventoryReceivingForm } = this.props;
    return (
      <View ref={this.inputRef}>
        {scan ?
          <View style={{
            ...styles.container,
            paddingTop: width ? 0 : 5
          }}>
            <BarcodeScannerComponent
              onBarCodeScanned={(e) => this.handleBarCodeScanned(e)}
              closeScanner={() => {
                //this.showScanner(false);
                if(scannerInput && (showScanner)){
                  this.setState({ scanerCanceled: true, scan: false }, ()=>{
                    setTimeout(() => {
                      inputFocus(this.textInputRef)
                    }, 500);
                  })
                }
              }}
              style={styles.absoluteFillObject}
            />
            {/* <TouchableOpacity style={styles.btnCancel}>
              <Text style={styles.btnCancelText} onPress={() => this.setState({ scan: false })}>
                Cancel
              </Text>
            </TouchableOpacity> */}
          </View>

          :
          <>
            {(this.state.dialogVisible && !width) &&
              <View style={{...styles.container,
                paddingTop: width ? 0 : 5,
                height: 150
              }}>
                <NewIssue
                  visible={this.state.dialogVisible}
                  id={id}
                  label={label}
                  onSubmitIssue={onSubmitIssue}
                  handleClose={() => this.setState({ dialogVisible: false })}
                />
              </View>
            }
            {!this.state.dialogVisible &&
              <View style={{
                ...styles.container,
                paddingTop: width ? 0 : 5
              }}>
                {
                  label ?
                    <Text style={styles.label}>
                      {label}
                    </Text>
                    : null
                }
                {
                  (isIssuable && isCompleted) &&
                  <TouchableOpacity style={{ paddingBottom: 10, paddingTop: 5 }} onPress={() => {
                    if (width) {
                      openIssue();
                    } else {
                      this.setState({ dialogVisible: true });
                    }
                  }}>
                    <Text style={{ color: colors.primary, fontWeight: 'bold' }}>Issue</Text>
                  </TouchableOpacity>
                }
                <View style={styles.inputContainer}>
                  <View style={styles.inputC}>
                    {
                      hideInput ? this.renderInputView() :
                        <TextInput
                          {...getNoAutofillProps()}
                          value={value}
                          editable={!defaultComponent}
                          ref={noAutofillRef(this.textInputRef)}
                          onFocus={() => {
                            setTimeout(() => {
                              if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                            }, 300);
                            if(!isInventoryReceivingForm && scannerInput && showScanner && !scanerCanceled){
                              this.showScanner(true);
                            }else if(scannerInput)this.setState({ scanerCanceled: false });
                          }}
                          onContentSizeChange={(event) => {
                            if(isMobileWeb()) return;
                            if (Platform.OS == 'ios') {
                              this.setState({ heightIOS: event.nativeEvent.contentSize.height });

                            } else {
                              this.setState({ height: event.nativeEvent.contentSize.height });

                            }
                          }}
                          style={{
                            borderColor: "#e7e7e7",
                            borderRadius: 5,
                            borderWidth: 1,
                            color: "#424242",
                            fontFamily: "Roboto",
                            fontSize: 20,
                            fontWeight: "400",
                            paddingLeft: 10,
                            height: Platform.OS === 'ios' ?
                              this.state.value !== '' ? this.state.heightIOS * 1.3 : this.props.placeholder && this.props.placeholder.length <= 50 ? this.state.heightIOS * 1.15 : this.state.heightIOS * 1.1 :
                              //Android
                              this.state.value == "" || !this.state.value
                                ? this.props.placeholder && this.props.placeholder.length >= this.getMinChar(width)
                                  ? this.props.placeholder.length <= 50 ? (this.state.height * (this.props.placeholder.length / this.getFirstDiv(width))) : this.props.placeholder.length <= 200 ? (this.state.height * (this.props.placeholder.length / this.getSecondDiv(width))) : (this.state.height * (this.props.placeholder.length / this.getThirdDiv(width)))
                                  : this.state.height
                                : (this.state.value.length / 31) <= 0 ? (this.state.height * (this.state.value.length / 28))
                                  : this.state.height,
                            fontStyle: this.state?.value == "" || !this?.state.value ? 'italic' : 'normal'
                          }}
                          multiline={true}
                          placeholder={this.props.placeholder}
                          placeholderTextColor={'rgb(0, 47, 108)'}
                          onChangeText={(val) => {
                            if (!defaultComponent) {
                              this.setState({ value: val });
                              onChange(id, val);
                            }
                          }}
                        />}
                  </View>
                  {
                    showScanner && !scannerInput &&
                    <View style={styles.btnC}>
                      <TouchableOpacity style={styles.btnScan}
                        disabled={defaultComponent}
                        onPress={() => {
                          this.showScanner(true);
                          setTimeout(() => {
                            if (handleFocusOnElement) handleFocusOnElement(this.inputRef.current);
                          }, 300);
                        }}
                      >
                        <Text style={styles.txtScan}>
                          Scan
                        </Text>
                      </TouchableOpacity>
                    </View>
                  }

                </View>
              </View>
            }
          </>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignSelf: "stretch",
    alignItems: "stretch",
    flexDirection: "column",
    // paddingLeft: 10,
    // paddingRight: 10,
    paddingTop: 5,
    // paddingBottom: 10,
  },
  label: {
    fontSize: 20,
    color: '#939598',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  inputContainer: {
    flex: 1,
    flexDirection: "column"
  },
  inputC: {
    flex: 3
  },
  btnC: {
    flex: 1
  },
  btnScan: {
    textAlign: "center",
    justifyContent: "center",
    backgroundColor: colors.primary,
    height: "100%",
    borderRadius: 5,
    marginTop: 10
  },
  txtScan: {
    textAlign: "center",
    justifyContent: "center",
    color: "white"
  },
  absoluteFillObject: {
    height: 400,
    width: "100%",
  },
  btnCancel: {
    backgroundColor: colors.orange,
    justifyContent: "center",
    borderRadius: 5,
    marginTop: 10,

  },
  btnCancelText: {
    justifyContent: "center",
    textAlign: "center",
    padding: 5,
    color: "white"
  }
});
